import React, { FunctionComponent, ReactElement, ReactNode } from 'react'

import { useTheme } from 'styled-components/native'

import { InlineInfoBanner } from './InlineInfoBanner'
import { tID } from '../../utils/utils'

export interface FormInfoBannerProps {
  text?: ReactNode
  title?: string
  trailingLink?: ReactElement
  testId?: string
}

/**
 * Info-banner shared across blended-care forms. Wraps the generic InlineInfoBanner with the common
 * "form" styling so every form banner reads as the same component.
 */
export const FormInfoBanner: FunctionComponent<FormInfoBannerProps> = ({ text, title, trailingLink, testId }) => {
  const { colors } = useTheme()

  if (!text) {
    return null
  }

  return (
    <InlineInfoBanner
      backgroundColor={colors.backgroundSection}
      textColor={colors.textSecondary}
      iconColor={colors.iconDefault}
      iconSize={24}
      title={title}
      text={text}
      trailingLink={trailingLink}
      testId={tID(testId ?? 'FormInfoBanner')}
    />
  )
}
